define(['jquery'], ($) => {
    'use strict';

    const activeClass = 'active';
    const selector = '.activate-on-click-target';

    return (config) => {
        $(document).on('click', selector, (e) => {
            e.preventDefault();
            let $parent = $(e.currentTarget);
            $parent.toggleClass(activeClass);
            $parent.attr('aria-pressed', $parent.attr('aria-pressed') === 'false');
        });
    };
});
